import React from 'react';

const VariantContext = React.createContext();
const MenuContext = React.createContext({
  schedules: [],
  categories: [],
  items: [],
  modifiers_sets: [],
  modifiers: [],
  disableModifiers: false,
  disableSchedules: false,
});
const CartContext = React.createContext();

export const VariantProvider = VariantContext.Provider;
export const VariantConsumer = VariantContext.Consumer;
export const MenuProvider = MenuContext.Provider;
export const MenuConsumer = MenuContext.Consumer;
export const CartProvider = CartContext.Provider;
export const CartConsumer = CartContext.Consumer;
